// Sidebar.jsx
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    FileText,
    CreditCard,
    Users,
    Settings,
    Menu,
    LogOut,
    BookOpen
} from 'lucide-react';
import { AuthService } from '../../services/AuthService';
import { Auth } from '../../Utils/Auth';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
    const navigate = useNavigate();
    const user = Auth.getUser();

    const handleLogout = () => {
        AuthService.logout(navigate);
    };

    const menuItems = [
        {
            icon: <FileText size={20} />,
            label: 'Annonces',
            path: '/dashboard/annonces',
            // submenu: [
            //     { label: 'En attente', path: '/dashboard/annonces/en-attente' },
            //     { label: 'Validées', path: '/dashboard/annonces/validees' },
            //     { label: 'Publiées', path: '/dashboard/annonces/publiees' },
            //     { label: 'Rejetées', path: '/dashboard/annonces/rejetees' },
            //     { label: 'Toutes', path: '/dashboard/annonces/toutes' }
            // ]
        },
        {
            icon: <CreditCard size={20} />,
            label: 'Paiements',
            path: '/dashboard/paiements'
        },
        {
            icon: <Users size={20} />,
            label: 'Utilisateurs',
            path: '/dashboard/utilisateurs'
        },
        {
            icon: <Settings size={20} />,
            label: 'Paramètres',
            path: '/dashboard/parametres'
        }
    ];

    return (
        <>
            {/* Overlay pour mobile */}
            {isOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={toggleSidebar}
                />
            )}

            {/* Sidebar */}
            <div className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
                {/* Header */}
                <div className="sidebar-header">
                    <div className="sidebar-logo">
                        <BookOpen size={24} className="text-white" />
                        <span className="sidebar-title">Journal</span>
                    </div>
                    <button
                        className="sidebar-toggle"
                        onClick={toggleSidebar}
                    >
                        <Menu size={20} />
                    </button>
                </div>

                {/* Navigation */}
                <nav className="sidebar-nav">
                    {menuItems.map((item, index) => (
                        <div key={index} className="nav-item-group">
                            <NavLink
                                to={item.path}
                                className={({ isActive }) =>
                                    `nav-item ${isActive ? 'nav-item-active' : ''}`
                                }
                            >
                                {item.icon}
                                <span className="nav-label">{item.label}</span>
                            </NavLink>

                            {/* Sous-menu pour les annonces */}
                            {item.submenu && (
                                <div className="submenu">
                                    {item.submenu.map((subItem, subIndex) => (
                                        <NavLink
                                            key={subIndex}
                                            to={subItem.path}
                                            className={({ isActive }) =>
                                                `submenu-item ${isActive ? 'submenu-item-active' : ''}`
                                            }
                                        >
                                            {subItem.label}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </nav>

                {/* User info et logout */}
                <div className="sidebar-footer">
                    <button
                        className="logout-button"
                        onClick={handleLogout}
                        title="Se déconnecter"
                    >
                        <LogOut size={20} />
                        <span>Déconnexion</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default Sidebar;